/* Progressive sizing help; native pickers, variants and cart events remain authoritative. */
(() => {
  if (customElements.get('sh-product-fit')) return;
  class ProductFit extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('[data-sh-size-dialog]');
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-sh-size-open]');
        if (opener && this.contains(opener) && this.dialog) {
          if (typeof this.dialog.showModal !== 'function') return;
          event.preventDefault();
          this.opener = opener;
          this.dialog.showModal();
          this.querySelector('[data-sh-size-close]').focus();
        }
        if (event.target.closest('[data-sh-size-close]')) this.dialog?.close();
      });
      if (this.dialog) {
        this.dialog.addEventListener('keydown', event => {
          if (event.key !== 'Tab') return;
          const controls = [...this.dialog.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex]:not([tabindex="-1"])')]
            .filter(control => !control.disabled && !control.hidden && control.getClientRects().length);
          const first = controls[0], last = controls[controls.length - 1];
          if (!first) return;
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault(); last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first.focus();
          }
        });
        this.dialog.addEventListener('close', () => {
          if (this.opener?.isConnected) this.opener.focus();
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        });
      }
      this.showExistingFitNotes();
    }

    showExistingFitNotes() {
      const source = this.querySelector('[data-sh-fit-source]')?.content;
      const disclosure = this.querySelector('[data-sh-fit-notes]');
      const output = this.querySelector('[data-sh-fit-notes-content]');
      if (!source || !disclosure || !output) return;
      // Only explicit fit headings; do not infer measurements from prose or size names.
      const normalized = text => text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim().replace(/:$/, '').toLowerCase();
      const heading = [...source.querySelectorAll('h1,h2,h3,h4,h5,h6,p')].find(node => /^(fit|fit & sizing|fit and sizing|fit & size|fit and size|sizing & fit|size & fit)$/.test(normalized(node.textContent)));
      if (!heading) return;
      for (let node = heading.nextElementSibling; node; node = node.nextElementSibling) {
        if (/^H[1-6]$/.test(node.tagName) || node.tagName === 'HR') break;
        if (node.tagName === 'P' && [...node.querySelectorAll('strong,b')].some(label => normalized(label.textContent) === normalized(node.textContent))) break;
        if (!['P', 'UL', 'OL', 'TABLE'].includes(node.tagName)) break;
        const copy = node.cloneNode(true);
        // Merchant description remains unchanged. Avoid duplicate DOM IDs and executable content.
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(child => child.removeAttribute('id'));
        copy.querySelectorAll('script,style,iframe,form').forEach(child => child.remove());
        output.append(copy);
      }
      if (output.textContent.trim()) disclosure.hidden = false;
    }
  }
  customElements.define('sh-product-fit', ProductFit);
})();
